import { render } from "./PromptButton.vue?vue&type=template&id=79ee463d&scoped=true"
import script from "./PromptButton.vue?vue&type=script&lang=js"
export * from "./PromptButton.vue?vue&type=script&lang=js"

import "./PromptButton.vue?vue&type=style&index=0&id=79ee463d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ee463d"]])

export default __exports__